

function getNumberOfGridItems() {
  gridItems = document.querySelectorAll(".grid-item");
    return gridItems.length;
}







function sortIndices(indices) {
    chunkSize = 16
    originalList = indices
    originalList.sort((a, b) => a - b);

    chunk_1 = []
    chunk_2 = []
    chunk_3 = []
    chunk_4 = []

    originalList.forEach(element => {
        if (element < chunkSize * 1) {
            chunk_1.push(element)
            // continue with next element
            return
        }

        if (element < chunkSize * 2) {
            chunk_2.push(element)
            return
        } 

        if (element < chunkSize * 3) {
            chunk_3.push(element)
            return
        }

        if (element < chunkSize * 4) {
            chunk_4.push(element)
            return
        }
    });

    chunk_1.sort(() => Math.random() - 0.5);
    chunk_2.sort(() => Math.random() - 0.5);
    chunk_3.sort(() => Math.random() - 0.5);
    chunk_4.sort(() => Math.random() - 0.5);

    sortedIndices = chunk_1.concat(chunk_2).concat(chunk_3).concat(chunk_4);    

    return sortedIndices
}


function getRandomUniqueIndices(round, numberOfGridItems, numberOfGridItemsToShow) {
    indices = [];

    allowedIndices = gridMatrixForRound(round);
    console.log("allowed indices", allowedIndices)

    while (indices.length < numberOfGridItemsToShow) {
        index = Math.floor(Math.random() * allowedIndices.length);
        if (!indices.includes(index) && allowedIndices.includes(index)) {
            indices.push(index);
        }
    }

    sortedIndices = sortIndices(indices);

    return sortedIndices
}



function animateSomeRandomGridItems(round, numberOfGridItemsToShow) {
    randomGridItems = [];
    indices = getRandomUniqueIndices(round, getNumberOfGridItems(), numberOfGridItemsToShow)
    console.log("animating indices", indices)

    for (i = 0; i < numberOfGridItemsToShow; i++) {
        randomGridItem = document.querySelectorAll(".grid-item")[indices[i]];
        randomGridItems.push(randomGridItem);
    }

    randomGridItems.forEach(element => {
        setTimeout(() => {
            animateGridItem(element, millisecondsPerItem);
        }, millisecondsPerItem * randomGridItems.indexOf(element));
        
    });    

    return indices
}


